angular.module('qkr').factory('notificationService', ($http, appConfig, $q) => ({

        addWhenProductSoldNotification(productId, emailAddresses) {
            const deferred = $q.defer();
            if (emailAddresses.length > 0) {
                const request = {
                    productId,
                    emailAddresses,
                    sendMinute,
                    sendHour,
                    sendDayOfWeek,
                    sendDayOfMonth
                };
                deferred.resolve($http.post(appConfig.apiUrl + 'notification/addWhenAProductIsSold', request));
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        },

        removeWhenProductSoldNotification(productId, emailAddresses) {
            if (emailAddresses.length > 0) {
                const request = {
                    productId,
                    emailAddresses
                };
                $http.post(appConfig.apiUrl + 'notification/removeWhenAProductIsSold', request);
            }
        },

        setEnabledFlagForWhenProductSoldNotification(productId, enabled, messageType) {
            if (enabled) {
                const cmd = {productId, messageType};
                $http.post(appConfig.apiUrl + 'notification/enableWhenAProductIsSold', cmd);
            } else {
                return $http.get(appConfig.apiUrl + 'notification/' + productId + '/disableWhenAProductIsSold');
            }
        },

        getNotificationsForProduct(product) {
            return $http.get(appConfig.apiUrl + 'notification/' + product.id + '/product');
        }

    }));



// WEBPACK FOOTER //
// ./src/services/notification.service.js